import { render, staticRenderFns } from "./NumScroll.vue?vue&type=template&id=6c8ab130&scoped=true"
import script from "./NumScroll.vue?vue&type=script&lang=js"
export * from "./NumScroll.vue?vue&type=script&lang=js"
import style0 from "./NumScroll.vue?vue&type=style&index=0&id=6c8ab130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ab130",
  null
  
)

export default component.exports